module.exports = __webpack_public_path__ + "static/media/task4Flower3.343743fa.png";